import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b984d032")

_pushScopeId("data-v-b984d032")
const _hoisted_1 = { class: "date-name-filter" }
const _hoisted_2 = { class: "form_item--date" }
const _hoisted_3 = { class: "form_item--date" }
const _hoisted_4 = { class: "form_item--text" }
const _hoisted_5 = { class: "-button -royalBlue" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_InputText = _resolveComponent("InputText")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("form", {
      onSubmit: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
    }, [
      _createVNode("div", null, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Calendar, {
            dateFormat: "yy-mm-dd",
            modelValue: _ctx.from,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.from = $event)),
            placeholder: _ctx.t('date (from)'),
            class: "date--from"
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_Calendar, {
            dateFormat: "yy-mm-dd",
            modelValue: _ctx.to,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.to = $event)),
            placeholder: _ctx.t('date (to)'),
            class: "date--to"
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_InputText, {
            type: "text",
            modelValue: _ctx.state.name,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.name = $event)),
            placeholder: _ctx.t('finding keywords (requested)')
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ]),
      _createVNode("button", _hoisted_5, [
        _createVNode("span", null, _toDisplayString(_ctx.t("search")), 1)
      ])
    ], 32)
  ]))
})